import * as ConfigTypes from 'config/ConfigTypes';
import { getDialogConfig } from "helpers/ConfigHelper";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { verifyFields } from 'helpers/AuthHelper';

export const getProfileUserItems = ({ configObjects }) => {
    let userFields = getDialogConfig({
        dialogMode: ConfigTypes.PROFILE_USER,
        configObjects, configName: "userconfig"
    });
    let fields = [...userFields, ...ConfigTypes.PROFILE_USER_BUTTONS];
    return fields;
}

export const getProfileData = ({ screenMode, configObjects }) => {
    switch (screenMode) {
        case ConfigTypes.PROFILE_USER:
            return getProfileUserItems({ configObjects });
        case ConfigTypes.PROFILE_USER_DIFF_INVOICE_ADDR:
        case ConfigTypes.PROFILE_USER_DIFF_DELIVERY_ADDR:
            return getDialogConfig({
                dialogMode: screenMode, configObjects,
                configName: "userconfig"
            });
        default:
            return [];
    }
}

export const handleMsg = ({ msg, formatMessage }) => {
    switch (msg) {
        case ConfigTypes.NOT_LOGGED_IN:
            return formatMessage({ id: "profile.notloggedin.msg" });
        case ConfigTypes.USER_UPDATED:
            return formatMessage({ id: "profile.userupdated.msg" });
        case ConfigTypes.SOMETHING_WENT_WRONG:
            return formatMessage({ id: "profile.somethingwentwrong.msg" });
        default:
            return msg;
    }
}

export const handleActionsBottomBtn = ({ screenMode }) => {
    switch (screenMode) {
        default:
            return ConfigTypes.PROFILE_ACTIONS;
    }
}

export const getScreenHeading = ({ screenMode, formatMessage }) => {
    let styleObj = { marginRight: '5px', color: '#d5001c' };
    switch (screenMode) {
        case ConfigTypes.PROFILE_USER:
            return (
                <div>
                    <span>
                        <FontAwesomeIcon icon={faUser} style={styleObj} />
                    </span>
                    <span>{formatMessage({ id: "profile.user" })}</span>
                </div>
            );
        default:
            return "";
    }
}

export const verifyProfile = ({ userInputs, configObjects }) => {
    let authForm = ConfigTypes.PROFILE_USER;
    let configInputs = getDialogConfig({
        dialogMode: authForm,
        configObjects, configName: "userconfig"
    });
    return verifyFields({ userInputs, authForm, configObjects, configInputs });
}